import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./new_index.css";
import "@fontsource/inter";
import App from "./App";
import { Provider as ReduxProvider } from 'react-redux';
import store from './store';
import AppContext from "./states/context/appContext";
import UserJourneyContext from "./states/context/userJourneyContext";
import UserOnboardingContext from "./states/context/userOnboardingContext";
import { ErrorBoundary } from "./components/shared/ErrorBoundary";

// Global safety net: catch unhandled async rejections and sync errors that
// escape React's error boundary (event handlers, setTimeout, etc.)
window.addEventListener('unhandledrejection', (event) => {
  console.error('[Global] Unhandled promise rejection:', event.reason);
});
window.onerror = (message, source, lineno, colno, error) => {
  console.error('[Global] Uncaught error:', { message, source, lineno, colno, error });
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <AppContext>
          <UserJourneyContext>
            <UserOnboardingContext>
              <App />
            </UserOnboardingContext>
          </UserJourneyContext>
        </AppContext>
      </ReduxProvider>
    </ErrorBoundary>
);
